import React from 'react';
import PropTypes from 'prop-types';

import { getAllBrands } from '../../api/allbrands';
import cogoToast from 'cogo-toast';

const LIMIT = 50;
const DEBOUNCE_MS = 250;

const AllBrandsData = props => {
  const {
    setIsFetching,
    isFetchingRef,
    page,
    curFilters,
    sortBy,
    sortDir,
    isFetching,
    results,
    setResults,
    totals,
    setTotals,
    curSearchVal,
    hasAllResults,
    setHasAllResults
  } = props;

  const isFetchingFirstPage = isFetching && page === 0;

  // Initial Fetch, use ref for immediacy check
  const setFetchingState = state => {
    setIsFetching(state);
    isFetchingRef.current = state;
  };

  const fetchResults = async () => {
    try {
      const { brands, totalCount, incompleteCount, hasNextPage } = await getAllBrands([
        ['query', curSearchVal ?? ''],
        ['page', page ?? 0],
        ['sortBy', sortBy.toLowerCase()],
        ['sortDir', sortDir.toLowerCase()],
        ...curFilters
      ]);
      setResults([...results.slice(0, page * LIMIT), ...brands]);
      setTotals({ total: totalCount, incomplete: incompleteCount });
      setHasAllResults(!hasNextPage);
    } catch (error) {
      console.error(error);
      if (isFetchingFirstPage) {
        cogoToast.error(`There was an issue fetching brands, please try again.`);
      } else {
        cogoToast.error(`There was an issue loading more brands. Please try again.`);
        setHasAllResults(true);
      }
    }
    setFetchingState(false);
  };

  // Debounced Updates
  let debouncedSearch = React.useRef();
  React.useEffect(() => {
    // Wait to fetch results until user has stopped typing
    setFetchingState(true);
    clearTimeout(debouncedSearch.current);
    debouncedSearch.current = setTimeout(() => fetchResults(), curSearchVal ? DEBOUNCE_MS : 0);
  }, [curSearchVal]);

  // Immediate Updates
  const filterValues = curFilters.map(i => JSON.stringify(i)).join('-');
  React.useEffect(() => {
    if (isFetchingRef.current) return;
    setFetchingState(true);
    fetchResults();
  }, [page, sortBy, sortDir, hasAllResults, filterValues]);

  return null;
};

AllBrandsData.propTypes = {
  setIsFetching: PropTypes.func.isRequired,
  isFetchingRef: PropTypes.object.isRequired,
  page: PropTypes.number.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDir: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  results: PropTypes.array.isRequired,
  setResults: PropTypes.func.isRequired,
  totals: PropTypes.object.isRequired,
  setTotals: PropTypes.func.isRequired,
  hasAllResults: PropTypes.bool.isRequired,
  setHasAllResults: PropTypes.func.isRequired,
  curSearchVal: PropTypes.string.isRequired,
  curFilters: PropTypes.array.isRequired
};

export default AllBrandsData;
